export default __webpack_public_path__ + "media/images/flaticons/user-73011e17ea1d1579221cae723ef5b4c8.png";